export default __webpack_public_path__ + "bfccbb867c8d8c531035b04c3d990540.svg";